// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.device-id[data-v-342d5d26]{\n\tcolor: var(--main-gray-4);\n\twhite-space:nowrap;\n\ttext-overflow: hidden;\n\toverflow:hidden;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
